
(function(){
/*
 * Obiekt konfigurujacy listy obiektów i ekrany szczegółów obiektów
 * Wpływa na takie elementy jak:
 * - BaseFilter - domyślny filtr listy
 * - konfigurację pól - czy możliwa edycja
 * - Domyślne parametry do tworzenie nowego obiektu
 */
function ListContext($injector, $q, $parse, Classes, CurrentUser, config, ContextService, Parent /*=null*/, EffectiveTime /*=null*/) {

	var self = this;
	this.config = config  // here config is guaranteed to be complete
	this.Parent = Parent || null;
	this.Class = Classes[config.classname];
	this.EffectiveTime = EffectiveTime || null;
	
	// top lists and parent-related nested lists
	this.fetchBaseFilter = function() {
		var filter = {};
		var name;
		for (name in this.config.basefilter) {
			var func = this.config.basefilter[name];
			filter[name] = $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		}
		return $q.all(filter);
	}

	
	// creates a new sub-module based on config.references configuration
	// sets the new Parent to the provided class instance
	this.getReferencedContext = function(newparent, i_or_path_or_class) {
		for (var i in config.references) {
			var tabconfig = ContextService.prepareConfig(config.references[i]);
			if (i === i_or_path_or_class
				|| tabconfig.name == i_or_path_or_class 
				|| tabconfig.classname == i_or_path_or_class
			) {
				return $injector.instantiate(ListContext, {config:tabconfig, ContextService:ContextService, Parent:newparent, EffectiveTime:this.EffectiveTime});
			}
		}
	}
	
	// creates a new object with default field values based on:
	// - Class fields defaults
	// - config.defaults with optional Parent dependency (if available - context create)
	this.fetchNewInstance = function(defaults) {
		defaults = defaults || {};
		return this.fetchClassDefaults().then(function(defaults1){
			return self.fetchConfigDefaults(defaults1).then(function(defaults2){
				var data = angular.extend({}, defaults1, defaults2, defaults);
				console.log('New object context resolved', data);
				var object = self.getClass().create(data);
				return object;
			});
		});
	}
	
	// detail 
	
	this.getClass = function() {
		return this.Class;
	}
	
	this.getEffectiveTime = function() {
		return this.EffectiveTime;
	}
	
	this.withEffectiveTime = function(effective_time) {
		return $injector.instantiate(ListContext, {config:this.config, ContextService:ContextService, Parent:this.Parent, EffectiveTime:effective_time});
	}
	
	this.getInstance = function(vid) {
		//var vid = id;
		//if (this.EffectiveTime) vid += ':' + this.EffectiveTime;
		return this.Class.get(vid);
	}
	
	this.cloneInstance = function(original) {
		return this.fetchClassDefaults().then(function(defaults){
			console.log('New object context resolved for clone', defaults);
			return self.getClass().clone_instance(original, defaults, ['edit', 'clone']).then(function(object){
				return self.fetchConfigDefaults(object).then(function(defaults2){
					angular.extend(object, defaults2);
					console.debug('Cloned object', object);
					return object;
				});
			});
		});
	}
	
	// support
	
	// returns an object filled with default values for class fields
	// based on the class configuration retrieved from the server
	this.fetchClassDefaults = function() {
		var defaults = {};
		var cls = this.getClass();
		var fields = cls.get_form_params();    // was: cls.fields
		for (var k in fields) {
    		var field = fields[k];
			if (field && typeof field['default'] != "undefined") {
				var func = $parse(field['default']);  // function(context, locals)
				defaults[field['name']] = func({$moment: moment, $user: CurrentUser.instance}, Classes); 
			}
    	}
    	return $q.all(defaults);
	}
	
	// returns an object filled with default values for class fields
	// based on the target context configuration
	this.fetchConfigDefaults = function(context) {
		var defaults = {};
		for (var name in this.config.defaults) {
    		var func = this.config.defaults[name];
			defaults[name] = $injector.invoke(func, null, {Object:context,Parent:Parent,CurrentUser:CurrentUser});
    	}
    	return $q.all(defaults);
	}
	
	
	// display
	
	this.getTitle = function() {
		return self.config.display.title;
	}
	this.getListTitle = function() {
		return self.config.display.ntitle;
	}
	this.getIcon = function() {
		return self.config.display.icon;
	}
	this.getName = function() {
		return self.config.name;
	}
	this.getCreateLabel = function() {
		if(self.config.display.createLabel)
			return self.config.display.createLabel;
		else
			return 'Create';
	}
	
	this.getTabs = function(location) {
		var tabs = [];
		for (var i in config.tabs) {
			var display = config.tabs[i].display;
			if (!location || display.location == location) {
				tabs.push(config.tabs[i]);
			}
		}
		return tabs;
	}

	this.getRefs = function(location) {
		var refs = [];
		for (var i in config.references) {
			var display = config.references[i].display;
			if (!location || display.location == location) {
				var tabconfig = ContextService.prepareConfig(config.references[i]);
				refs.push(tabconfig);
			}
		}
		return refs;
	}
	
	this.getClientActions = function(location) {
		var actions = [];
		for (var i in config.clientActions) {
			var action = config.clientActions[i];
			if (action.location == location) {
				actions.push(action);
			}
		}
		return actions;
	}

	// returns predefined mandatory filters for lists
	this.getPredefinedFilters = function() {
		if (typeof this.config.predefinedFilters == "function") {
			var func = this.config.predefinedFilters;
			return $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		} else {
			return this.config.predefinedFilters;
		}
	}

	// return preconfigured cols from main.js
	this.getMergeGridColumnDefs = function() {
		if (typeof this.config.mergeGridColumnDefs == "function") {
			var func = this.config.mergeGridColumnDefs;
			return $injector.invoke(func, null, {Parent:Parent,CurrentUser:CurrentUser});
		} else {
			return this.config.mergeGridColumnDefs;
		}
	}
}


function ContextService(Modules, Classes, $injector) {
	
	this.modules = Modules;
	
	/*
		// Example Configuration
		
		var config = {
			name:"users", 
			classname: "Person",
			display: {
				ntitle:"Users", 
				title:"User", 
				icon:"fa fa-users",
				// simpleui: true,
			},
			listController: 'ModuleListController',
			listControllerAs: 'mCtrl',
			objectController: 'ModuleObjectController',
			objectControllerAs: 'mCtrl',
			createController: 'ModuleObjectController',
			createControllerAs: 'mCtrl',
			listTemplateUrl: 'framework/partials/admin/list.html',
			objectTemplateUrl: 'framework/partials/admin/object.html',
			createTemplateUrl: 'framework/partials/admin/object-create.html',
			tabTemplateUrl: 'framework/partials/admin/tab-list.html',
			
			import: "some_default_config_name",
			
			basefilter: {
				'manager.id': function(CurrentUser) {  // injectable locals: Parent,CurrentUser
					return CurrentUser.instance.__id;  // can be a promise
				}
			},
			
			defaults: {
				manager: function(CurrentUser) {  // injectable Object,Parent,CurrentUser
					return CurrentUser.instance;  // can be a promise
				}
			},
			
			clientActions: [{
				'location': 'actions',
				'perm': 'create',
				'btn': 'New email',
				'icon': 'far fa-download fa-fw',
				'condition': function(Object) {return Object.has_email_address},
				'action': function(Object, $state) {  // injectable Object
					return Object.fetch().then(function(){
						var mailto = "mailto:" + Object.email;
						window.location = mailto;
					});
				}
			}]
			
			mergetabs: [
				{
					name: 'edit2',
					display: {location: 'right', title: 'Edit', icon: 'glyphicon glyphicon-edit'},
					enabled: function(Object, Config) {return Object.__perms.edit && Object.__id==Object.__vid},
					templateUrl: 'framework/partials/admin/object-editform.html',
					// savegroups: ['edit'],
					// formlayout: [ ['edit-l', 'edit-r'], ['edit-w'] ]
				},
			],
			
			
			references: [
				{
					import: "customers",
					
					foreignKey:'subagent',  // only in referenced context
					// OR
					basefilter: {
						'subagent.id': function(Parent) {  // injectable locals: Parent,CurrentUser
							return Parent.__id;  // can be a promise
						}
					}
					defaults: {
						subagent: function(Parent) {  // injectable locals: Object,Parent,CurrentUser
							return Parent;  // can be a promise
						}
					},
					
					controller:'ModuleListController', 
					templateUrl: 'framework/partials/admin/tab-list.html'
					
					display: {
						location: 'side'
					}
				},
			],

			fetchLevel: 1,

			predefinedFilters: [
				{
					title: 'All',
					icon: 'fa fa-list',
					filter: {},
					mandatory: true,  // cannot delete
					dynamic: false,   // saved, do not offer save dialog
				}
			],

			mergeGridColumnDefs: [],
		}
	*/
	
	this.makeDefaultConfig = function(Class) {
		return {
			"name": Class.classname,
			"classname": null,  // REQUIRED - the only required field
			"display": {
				"title": Class.classname.replace(/(\w)([A-Z])/g, '$1 $2'),
				"ntitle": "List of " + Class.classname.replace(/(\w)([A-Z])/g, '$1 $2'),
				"icon": "fa fa-cubes"
			},
			//"listController": "ModuleListController",
			//"listControllerAs": "mCtrl",
			//"templateUrl": 'framework/partials/admin/list.html',
			"references": null,
			tabs: [
				{
					name: 'info',
					display: {location: 'left', title: 'Details', icon: 'glyphicon glyphicon-th'},
					enabled: function(Object, Config) {return !(Config.display.simpleui) || (Object.__perms && !Object.__perms.edit)},
					templateUrl: 'framework/partials/admin/object-details.html',
				},
				{
					name: 'edit',
					display: {location: 'right', title: 'Edit', icon: 'glyphicon glyphicon-edit'},
					enabled: function(Object, Config) {return Object.__perms.edit && Object.__id==Object.__vid},
					templateUrl: 'framework/partials/admin/object-editform.html',
				},
				{
					name: 'hist',
					display: {location: 'right', title: 'History', icon: 'fa fa-history'},
					enabled: function(Object, Config) {return Object.__perms.history},
					templateUrl: 'framework/partials/admin/object-history.html',
				}
			],
			predefinedFilters: [
				{
					title: 'All items',
					icon: 'fa fa-list',
					filter: {},
					mandatory: true,  // cannot delete
					dynamic: false,   // saved, do not offer save dialog
				}
			],
		};
	}
	
	this.findConfig = function(name_or_class) {
		for (var i in this.modules) {
			var module = this.modules[i]
			if (module.name == name_or_class) return module;
			if (module.classname == name_or_class) return module;
		}
		throw "No module defined for: " + name_or_class
		return null;
	}
	
	this.getConfig = function(name_or_class) {
		var config = this.findConfig(name_or_class);
		return config? this.prepareConfig(config): null;
	}
	
	this.prepareConfig = function(config) {
		// import other config if needed
		config = angular.copy(config);
		if (config.import) {
			var imported = this.getConfig(config.import);
			if (!imported) throw "Import failed: " + config.import;
			//config = angular.extend(config, imported);
			for (var key in imported) {
				if (imported[key] !== null && typeof imported[key] === 'object') {
					config[key] = angular.copy(config[key]) || {}
					for (var k in imported[key]) {
						if (!config[key][k]) config[key][k] = imported[key][k];
					}
				} else {
					if (!config[key]) config[key] = imported[key];
				}
			}
		}

		// add any missing default options
		var default_config = this.makeDefaultConfig(Classes[config.classname])
		config = angular.extend(default_config, config);
		
		// merge custom tabs
		if (config.mergetabs) {
			for (var mi=0; mi<config.mergetabs.length; mi++) {
				var tabmerged = false;
				for (var di=0; di<config.tabs.length; di++) {
					if (config.tabs[di].name == config.mergetabs[mi].name) {
						tabmerged = true;
						angular.extend(config.tabs[di], config.mergetabs[mi]);
					}
				}
				if (!tabmerged) {
					config.tabs.push(config.mergetabs[mi]);
				}
			}
		}
		
		// expand foreignKey shortcut
		if (config.foreignKey) {
			config.basefilter = angular.copy(config.basefilter) || {}
			config.basefilter[config.foreignKey + '.id'] = function(Parent) {
				return Parent.__id;
			}
			if (!config.foreignKey.match(/\./)) {
				config.defaults = angular.copy(config.defaults) || {}
				config.defaults[config.foreignKey] = function(Parent) {
					return Parent;
				}
			}
		}
		
		return config;
	}
	
	// tworzy pusty kontekst dla list obiektów pierwszego poziomu
	this.getContext = function(name_or_class, effective_time) {
		var config = this.getConfig(name_or_class);
		if (!config) return null;
		var ret = $injector.instantiate(ListContext, {config:config, ContextService:this, Parent:null, EffectiveTime:effective_time});
		return ret;
	}
	
}


angular.module('admin').service('ContextService', ContextService);

})();